import { defineStore } from "pinia";
import { AuthAPI, MeAPI } from "@/utils/generated/api-public";

export const useAuthStore = defineStore("auth", () => {
  const me = ref(null);
  const organization = computed(() => me.value?.organizations?.[0]);
  const auth = ref(null);

  async function authenticate(payload = undefined) {
    let new_auth = payload;
    if (typeof payload === "undefined") {
      if (auth.value) {
        new_auth = auth.value;
      } else if (localStorage?.getItem("bearer-token")) {
        new_auth = {
          access_token: localStorage?.getItem("bearer-token"),
          expires_in: null,
          expires_date: null,
        };
      }
    }
    if (!new_auth) {
      return null;
    }
    /**
     * Calculate expires_date if not set
     */
    if (!new_auth.expires_in) {
      new_auth.expires_in = 4 * 3600;
      new_auth.expires_date = null;
    }
    if (!new_auth.expires_date) {
      new_auth.expires_date = new Date().getTime() + new_auth.expires_in * 1000;
    }
    if (new_auth.expires_date < new Date().getTime() + 30000) {
      throw new Error("JWT token is expired");
    }
    /**
     * Don't load me from server if already loaded and auth still valid
     */
    if (auth.value?.access_token === new_auth?.access_token && me.value) {
      return me.value;
    }

    auth.value = new_auth;
    if (new_auth?.access_token) {
      localStorage.setItem("bearer-token", new_auth.access_token);
    } else {
      localStorage.removeItem("bearer-token");
    }

    //  Load me from server
    try {
      me.value = await MeAPI.getMe();
      if (!me.value && auth.value) {
        auth.value = null;
        localStorage.removeItem("bearer-token");
      }
    } catch (err) {
      console.error("Unexpected error during authentication", err);
      logout();
    }
    return me.value;
  }

  async function authenticate_by_cookie() {
    try {
      me.value = await MeAPI.getMeByCookie();
    } catch (err) {
      console.error("Failed to authenticate by cookie", err);
      await logout();
    }
    return me.value;
  }
  async function logout() {
    auth.value = null;
    me.value = null;
    localStorage.removeItem("bearer-token");
    await AuthAPI.logout();
  }

  return {
    me,
    organization,
    auth,
    authenticate,
    logout,
    authenticate_by_cookie,
  };
});
